<template>
  <div  :class="fullView ? 'full-view' : 'claims-value-employer-echarts'">
    <v-chart class="chart" :option="option" ref="chartRef" :init-options="{ renderer: 'svg' }"/>
  </div>
</template>

<script>
import { use } from 'echarts/core'
import { BarChart } from 'echarts/charts'
import { TooltipComponent, GridComponent } from 'echarts/components'
import { SVGRenderer } from 'echarts/renderers'
import VChart from 'vue-echarts'
import { getDefaultChartTextStyle, getBarNoDataOptions } from '@/helpers/insightsCharts'
import { useChartResize } from '@/composables/useChartResize'
import { COLOR_PALETTE } from '@/helpers'
import { emitChartFinished } from '@/utils/insightsPdfUtils'

use([TooltipComponent, GridComponent, BarChart, SVGRenderer])

export default {
  name: 'ClaimsValueEmployerChart',
  components: {
    VChart
  },
  props: {
    resultSet: {
      type: Object,
      required: true,
      default: () => ({})
    },
    fullView: {
      type: Boolean
    }
  },
  setup () {
    const { chartRef, handleResize } = useChartResize()

    return {
      chartRef,
      handleResize
    }
  },
  data () {
    return {
      option: {
        animation: !this.fullView,
        title: {
          text: this.$t('insights.charts.claimsValueEmployer.title'),
          top: 0,
          left: 'center',
          textStyle: getDefaultChartTextStyle(this.fullView)
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 90,
              fontSize: 10,
              show: this.fullView
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: this.$t('insights.charts.claimsValueEmployer.seriesName'),
            type: 'bar',
            barWidth: '70%',
            itemStyle: {
              color: COLOR_PALETTE[1]
            },
            data: []
          }
        ]
      }
    }
  },
  methods: {
    formatCentsToAmount (cents) {
      return (parseInt(cents) / 100).toFixed(2)
    },
    updateData () {
      const noDataOptions = getBarNoDataOptions(this.resultSet, this.fullView, this.option)
      if (noDataOptions) {
        this.option = {
          ...this.option,
          ...noDataOptions,
          title: this.option.title
        }
        emitChartFinished(this, true)
        return
      }

      const pivot = this.resultSet.chartPivot()
      const labels = pivot.map((r) => r.x)
      const data = pivot.map((r) => (this.formatCentsToAmount(r['variations_parts.agreedvaluecents'])))

      this.option.xAxis[0].data = labels
      this.option.series[0].data = data.map((value, index) => ({
        value,
        itemStyle: {
          color: COLOR_PALETTE[1],
          borderWidth: 1
        }
      }))
      emitChartFinished(this, false)
    }
  },
  mounted () {
    this.updateData()
  }
}
</script>

<style scoped>
.claims-value-employer-echarts {
  height: 250px;
}
.full-view {
  height: var(--full-view-chart-height);
  width: var(--full-view-chart-width);
}
</style>
